import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';
interface Notification {
  id: number;
  type: NotificationType;
  message: string;
  description?: string;
  /** Work items the entry is about; the drawer links each to the wizard. */
  workItemIds?: (number | string)[];
  timestamp: string;
}

interface NotificationState {
  notifications: Notification[];
  drawerOpen: boolean;
  isLegacyVersion: boolean;
}

const initialState: NotificationState = {
  notifications: [],
  drawerOpen: false,
  isLegacyVersion: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setIsLegacyVersion: (state, action: PayloadAction<boolean>) => {
      state.isLegacyVersion = action.payload;
    },
    setNotificationDrawerOpen(state, action: PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
    },
    addNotification: (
      state,
      action: PayloadAction<Omit<Notification, 'id' | 'timestamp'>>
    ) => {
      // Newest first, so the first entry holds the highest id. Several
      // entries added in the same millisecond still get distinct ids.
      const lastId = state.notifications[0]?.id ?? 0;
      state.notifications.unshift({
        id: Math.max(Date.now(), lastId + 1),
        timestamp: new Date().toLocaleString(),
        ...action.payload,
      });
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(
        (notif) => notif.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
});

export const {
  setNotificationDrawerOpen,
  addNotification,
  removeNotification,
  clearNotifications,
  setIsLegacyVersion,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
